import { useEffect } from 'react';
import { useHistory } from "react-router-dom";
import customAxios from "../API/customAxios";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { logoutRequest } from "../../authConfig";

export default function Logout() {
    const { instance } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const history = useHistory();

    useEffect(() => {
        customAxios.get("/logout").then(
            (response) => {
                localStorage.removeItem('employee_name');
                localStorage.removeItem('token');
                localStorage.removeItem('staff_duty');
                localStorage.removeItem('selectedIndex');
                localStorage.removeItem('isApplicationOpen');
                localStorage.removeItem('isMyRequestOpen');
                localStorage.removeItem('isLeaveApprovalOpen');
                localStorage.removeItem('isHRAdminOpen');
                localStorage.removeItem('isHrAdminRole');
                localStorage.removeItem('department_id');

                // LOGOUT AD
                if (instance && isAuthenticated) {
                    instance.logoutRedirect(logoutRequest).catch(e => {
                        console.error(e);
                    });
                } else {
                    history.push("/login");
                }
            },
            // COOKIE ERROR
            (error) => {
                console.error(error);
            });
    }, []);

    return null;

}